export default {
  api: {
    basicAuth: "Basic ZGV2QGxhdy10ZWNoOkRldlBhc3N3b3Jk",
    url: "http://dev.briztechnologies.com/api",
  },
};
